export const TEAM_MEMBER_DEAD_ZONE = 0.18;

function clamp01(value: number) {
  return Math.min(Math.max(value, 0), 1);
}

function easeInOutCubic(value: number) {
  const progress = clamp01(value);
  return progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
}

export function getTeamMemberWeights(browseProgress: number, total: number, initialIndex = 0) {
  const safeTotal = Math.max(total, 1);
  const safeInitialIndex = Math.min(Math.max(initialIndex, 0), safeTotal - 1);
  const weights = new Array<number>(safeTotal).fill(0);

  if (safeTotal === 1) {
    weights[0] = 1;
    return weights;
  }

  const clampedBrowseProgress = clamp01(browseProgress);
  if (clampedBrowseProgress <= 0) {
    weights[safeInitialIndex] = 1;
    return weights;
  }

  const scaled = clampedBrowseProgress * (safeTotal - 1);
  const leftIndex = Math.floor(scaled);
  const rightIndex = Math.min(leftIndex + 1, safeTotal - 1);
  const fractional = scaled - leftIndex;

  if (leftIndex === rightIndex) {
    weights[leftIndex] = 1;
    return weights;
  }

  if (fractional <= TEAM_MEMBER_DEAD_ZONE) {
    weights[leftIndex] = 1;
    return weights;
  }

  if (fractional >= 1 - TEAM_MEMBER_DEAD_ZONE) {
    weights[rightIndex] = 1;
    return weights;
  }

  const normalizedBlend = (fractional - TEAM_MEMBER_DEAD_ZONE) / (1 - TEAM_MEMBER_DEAD_ZONE * 2);
  const easedBlend = easeInOutCubic(normalizedBlend);

  weights[leftIndex] = 1 - easedBlend;
  weights[rightIndex] = easedBlend;
  return weights;
}

export function getTeamActiveMemberIndex(browseProgress: number, total: number, initialIndex = 0) {
  const weights = getTeamMemberWeights(browseProgress, total, initialIndex);
  let activeIndex = 0;
  let activeWeight = -1;

  weights.forEach((weight, index) => {
    if (weight > activeWeight) {
      activeWeight = weight;
      activeIndex = index;
    }
  });

  return activeIndex;
}
